import { css } from '@emotion/react';
import { Link } from 'react-router';
import { BirdiTheme, blocks } from '@birdi/theme';
import { maps as mapsAPI, stroot } from '@birdi/js-sdk';
import { useNavigate } from 'react-router';

const cardStyle = (theme: BirdiTheme) => css`
  ${blocks.sharedMapCardStyle(theme)};
  background: ${theme.mono20};
  justify-content: center;
  align-items: center;
`;

type CreateMissionProps = {
  newMaps?: boolean;
};
export const CreateMissionCard = ({ newMaps = false }: CreateMissionProps) => {
  const navigate = useNavigate();
  const onCreateMapClick = async () => {
    if (newMaps) {
      const res = (await mapsAPI.postMap(stroot('nwmap2')))?.body;
      if (res && res.id) {
        navigate(`/map/next/${res.id}`);
      }
    } else {
      // navigate('/map/missions/plan');
    }
  };
  return (
    <button
      type="button"
      onClick={onCreateMapClick}
      css={(theme: BirdiTheme) => css`
        ${cardStyle(theme)};
        cursor: pointer;
        background-image: url('https://birdi-public.s3-ap-southeast-2.amazonaws.com/street-background.png');
        background-position: center;
        background-size: cover;
        opacity: 0.5;
        min-height: 16rem;
        cursor: ${newMaps ? 'pointer' : 'default'};
      `}
    >
      {newMaps && (
        <span
          css={(theme) => css`
            color: ${theme.mono98};
            font-weight: bold;
          `}
        >
          + Create a map
        </span>
      )}
    </button>
  );
};

export const EmptyCard = () => (
  <div
    css={(theme: BirdiTheme) => css`
      ${cardStyle(theme)};
      background-color: ${theme.mono20};
    `}
  />
);
